import React, { ReactNode } from 'react';
import { FormCheckbox } from '../FormCheckbox';
import { Controller } from 'react-hook-form';
import { CheckboxProps } from '@mui/material';
import { Control } from 'react-hook-form/dist/types/form';
import { FieldValues } from 'react-hook-form/dist/types/fields';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';

interface Props<FormValues extends FieldValues = FieldValues> {
  label: ReactNode;
  control: Control<FormValues>;
  checkboxProps?: CheckboxProps;
  extraAction?: (nextVale: boolean) => void;
  name: UseControllerProps<FormValues>['name'];
}

export const CheckboxField = <FormValues extends FieldValues = FieldValues>({
  name,
  label,
  control,
  extraAction,
  checkboxProps = {},
}: Props<FormValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, ref } }) => (
        <FormCheckbox
          label={label}
          inputRef={ref}
          checked={!!value}
          onChange={(even_, checked) => {
            onChange(checked);
            extraAction?.(checked);
          }}
          {...checkboxProps}
        />
      )}
    />
  );
};
